import { motion } from "framer-motion"
import * as Icons from "lucide-react"
import { useTranslation } from "react-i18next"

export default function Services({ services }) {
  const { t } = useTranslation()
  return (
    <section
      id="sluzby"
      className="py-24 bg-white dark:bg-gray-800 px-4 scroll-mt-4 md:scroll-mt-10"
    >
      <motion.h2
        initial={{ y: 20, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
        className="text-3xl font-semibold text-center mb-12 text-primary"
      >
        {t("servicesSection.title")}
      </motion.h2>
      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {services.map((item, idx) => {
          const Icon = Icons[item.icon]
          return (
            <motion.div
              key={idx}
              whileInView={{ opacity: 1, y: 0 }}
              initial={{ opacity: 0, y: 50 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.03, transition: { duration: 0.2 } }}
              transition={{ duration: 0.6, delay: idx * 0.2 }}
              className="p-6 shadow-lg rounded-xl border border-gray-100 dark:border-gray-700 dark:bg-gray-900"
            >
              <Icon className="w-12 h-12 text-primary mb-4" />
              <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
              <p className="text-gray-600 dark:text-gray-400">
                {item.description}
              </p>
            </motion.div>
          )
        })}
      </div>
    </section>
  )
}
